import { actionDeclarer } from '../services/actionDeclarer';

export const {
	SET_DOCUMENT,
	SET_EVAL_ERROR,
	SET_EVALUATION
} = actionDeclarer;

const submissionsReducer = (
	state,
	{
		type,
		payload
	}
) => {
	switch ( type ) {
		case SET_DOCUMENT:
			return {
				...state,
				document: payload
			};
		case SET_EVAL_ERROR:
			return {
				...state,
				evalError: payload
			};
		case SET_EVALUATION:
			return {
				...state,
				evaluation: payload
			};

		default:
			return state;
	}
};

export default submissionsReducer;
